module.exports = __webpack_public_path__ + "static/event-7bb0b3a8a8ba1db50e57cc6cba8d6177.png";